import { Joi } from 'app-webtech-core/schemas';

const isError = (value) => value instanceof Error;

const defaultValidator = Joi.any();

const payloadValidatorEnhancer = (payloadValidator) => payloadValidator.label('payload');

export const actionCreator = (type, payloadValidator = defaultValidator) => (payload) => {
  let parsedPayload;
  let error;
  if (isError(payload)) {
    error = true;
    parsedPayload = payload;
  } else {
    const { error: validationError, value } = Joi.validate(
      payload,
      payloadValidatorEnhancer(payloadValidator),
    );
    if (validationError) {
      parsedPayload = validationError;
      error = true;
    } else {
      parsedPayload = value;
    }
  }

  return { type, payload: parsedPayload, error };
};
